import { render, staticRenderFns } from "./AddFeedTankModal.vue?vue&type=template&id=27172480&scoped=true&"
import script from "./AddFeedTankModal.vue?vue&type=script&lang=ts&"
export * from "./AddFeedTankModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddFeedTankModal.vue?vue&type=style&index=0&id=27172480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27172480",
  null
  
)

export default component.exports